<i18n src="@/translations/FinLexiconOverlay.json"></i18n>
<template>
  <v-navigation-drawer app
                       right
                       temporary
                       touchless
                       v-model="drawer"
                       style="z-index: 501"
                       :width="width"
                       class="fin-lexicon-drawer">

    <v-container class="d-flex flex-column py-0 pt-3" style="height: inherit; overflow: hidden; min-width: 100%">
      <v-row class="close_nav_buttons d-flex flex-grow-0">
        <v-col v-if="showOnlyEntry"
               :style="!this.showOnlyEntry ? 'background-color: '+ $finColors.secondaryBlue : ' '"
               class="pb-0 pt-3">
          <v-btn class="nav"
                 icon
                 large
                 @click="showOnlyEntry=!showOnlyEntry"
                 :style="'color: ' + $finColors.primaryDark">
            <v-icon class="nav-icon" large>icon-menu</v-icon>
          </v-btn>
        </v-col>
        <v-col v-else
               class="pt-3"
               :cols="`${$vuetify.breakpoint.smAndDown ? 8 : 5}`"
               :style="!this.showOnlyEntry ? 'background-color: ' + $finColors.secondaryBlue : ' '">
          <h3 v-if="$vuetify.breakpoint.smAndDown && !showOnlyEntry"
              class="mb-0"
              style="font-size: 24px">
            <v-icon class="lexicon-icon d-inline-block" large>icon-lexicon</v-icon>
            <span style="vertical-align: sub; color: #fff;" v-html="$t('FinLexiconOverlay.lexicon_title')"/>
          </h3>
        </v-col>
        <v-col :cols="`${$vuetify.breakpoint.smAndDown ? 4:7}`"
               :style="(getEntryWidthByCol === 0) ? 'background-color: ' + $finColors.secondaryBlue : ' '"
               class="pb-0 pt-3">
          <v-btn class="close"
                 icon
                 large
                 @click="closeBtn()"
                 style="float: right;">
            <v-icon
              :style="(getEntryWidthByCol === 0) ? 'color: '+$finColors.white : 'color: ' + $finColors.primaryDark"
              class="nav-icon"
              large>
              icon-close
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row class="content flex-grow-10 pa-0 mt-0">

        <v-col :cols="getMenuWidthByCol"
               :style="{'background-color': '$finColors.secondaryBlue;'}"
               class="fin-lexicon d-flex flex-column"
               v-if="!showOnlyEntry"
               style="padding: 3vh">

          <div v-if="$vuetify.breakpoint.mdAndUp" class="mb-2">
            <h3 style="font-size: 24px">
              <v-icon class="lexicon-icon">icon-lexicon</v-icon>
              <span class="pt-2" style="vertical-align: middle; " v-html="$t('FinLexiconOverlay.lexicon_title')"/>
            </h3>
          </div>

          <fin-data-loader :resolver="loadGlossar">
            <template #content>
              <fin-lexicon-glossar v-model="activeEntryGlossar"
                                   :drawer="drawer"
                                   :showOnlyEntry="showOnlyEntry"
                                   :entries="currentLanguageEntries"
                                   @input="entryClicked"
              />
            </template>
          </fin-data-loader>
        </v-col>

        <v-col :cols="getEntryWidthByCol"
               :style="(getEntryWidthByCol === 0) ?  'overflow: auto' : 'overflow: visible'"
               :class="$vuetify.breakpoint.xs ? 'pa-4 pt-12' : 'pa-4'">

          <fin-vue-scroll ref="scroller"
                          :height="entryHeight">
            <template #scrollableContent>
              <fin-lexicon-entry-not-found v-if="activeEntryGlossar && activeEntryGlossar.unknown"/>
              <fin-data-loader v-resize="calculateHeighth"
                               overlay
                               :resolver="loadArticle"
                               :params="activeEntryGlossar.ref"
                               v-else-if="activeEntryGlossar">
                <template #content="{data}">
                  <ReferenceHandler @entryClicked="setActiveGlossarEntry">
                    <entry-display :entry="data"/>
                  </ReferenceHandler>
                </template>
              </fin-data-loader>
            </template>

            <template #nonScrollableFooter>
              <v-col cols="12" ref="nextEntyCol" v-if="next">
                <v-divider class="pb-2"></v-divider>
                <v-btn style="float: right;"
                       @click="setActiveGlossarEntry(next)"
                       text
                       :style="$vuetify.breakpoint.smAndDown ? 'font-size: 13px' : ''">
                  {{ next.text || next.title }}
                  <v-icon class="pl-3">icon-arrow-link-right</v-icon>
                </v-btn>
              </v-col>
            </template>
          </fin-vue-scroll>
        </v-col>
      </v-row>
    </v-container>

  </v-navigation-drawer>
</template>

<script>
import FinLexiconGlossar from '@/components/common/lexicon/LexiconGlossar/index'
import {EventBus} from '@/plugins/fincraft'
import FinLexiconEntryNotFound from "@/components/common/lexicon/LexiconEntryNotFound/index"
import FinVueScroll from "@/components/common/vuescroll"
import FinDataLoader from "@/components/common/DataLoader"
import EntryDisplay from "@/components/common/lexicon/LexiconOverlay/EntryDisplay"
import ReferenceHandler from "@/components/common/lexicon/LexiconOverlay/ReferenceHandler"
import LexiconAPI from "@/components/common/lexicon/LexiconAPI"

export default {
  name: 'FinLexiconOverlay',
  components: {
    ReferenceHandler,
    EntryDisplay,
    FinDataLoader,
    FinLexiconEntryNotFound,
    FinLexiconGlossar,
    FinVueScroll
  },
  data() {
    return {
      drawer: false,
      entryHeight: '200px',
      activeEntryGlossar: null,
      showOnlyEntry: false,
      glossarEntries: null,
      lexiconGlossarDesktopWidth: '70%',
      showOnlyEntryDesktopWidth: '50%',
    }
  },
  computed: {
    currentLanguageEntries() {
      const lang = this.$i18n.locale === "en" ? "en-gb" : "de-de"
      return this.glossarEntries.filter(item => item.lang === lang)
    },
    next() {
      if (this.activeEntryGlossar && !this.activeEntryGlossar.unknown && this.currentLanguageEntries) {
        let index = this.activeEntryGlossar.index
        if (!index) {
          //preparsed
          index = this.currentLanguageEntries.find(e => e.ref === this.activeEntryGlossar.ref).index
        }
        if (index >= 0 && index < this.currentLanguageEntries.length - 1) {
          return this.currentLanguageEntries[index + 1]
        }
      }
      return null
    },
    width() {
      let res = undefined
      if (this.$vuetify.breakpoint.mdAndUp && this.showOnlyEntry) {
        res = this.showOnlyEntryDesktopWidth
      } else if (this.$vuetify.breakpoint.lgAndUp && !this.showOnlyEntry) {
        res = this.lexiconGlossarDesktopWidth
      } else {
        res = '100%'
      }
      return res
    },
    getEntryWidthByCol() {
      let cols = undefined

      if (this.showOnlyEntry) {
        cols = 12
      } else if (this.$vuetify.breakpoint.smAndDown && !this.showOnlyEntry) {
        cols = 0
      } else {
        cols = 7
      }
      return cols
    },
    getMenuWidthByCol() {
      let cols = undefined

      if (this.showOnlyEntry) {
        cols = 0
      } else if (this.$vuetify.breakpoint.smAndDown && !this.showOnlyEntry) {
        cols = 12
      } else {
        cols = 5
      }

      return cols
    }
  },
  watch: {
    drawer(val) {
      EventBus.$emit("lexiconVisible", val)
      if (val) {
        this.$nextTick(() => {
          setTimeout(this.calculateEntryHeight, 350)
        })
      }
    },
  },
  methods: {
    loadGlossar: LexiconAPI.loadGlossar,
    loadArticle: LexiconAPI.loadArticle,
    calculateHeighth() {
      if (this.$refs.scroller) {
        let footerHeight = 0
        try {
          footerHeight = this.$refs.nextEntyCol.offsetHeight
        } catch (e) {
          //
        }
        const height = window.innerHeight - this.$refs.scroller.$el.getBoundingClientRect().top - footerHeight - 40
        this.entryHeight = height + "px"
      }
    },

    entryClicked() {
      if (this.$vuetify.breakpoint.mdAndDown) {
        this.showOnlyEntry = true
      }
    },
    closeBtn() {
      this.drawer = false
    },
    setActiveGlossarEntry(newEntry) {
      this.activeEntryGlossar = newEntry
    },
    async showLexicon(dataValue, showOnlyLexiconEntry, showLexicon = false) {
      this.showOnlyEntry = showOnlyLexiconEntry

      if (!this.glossarEntries) {
        await this.loadGlossar()
      }

      if (dataValue) {
        const newEntry = this.findEntryByKey(dataValue)
        this.activeEntryGlossar = newEntry || {unknown: true}
      } else {
        if (showLexicon) {
          this.activeEntryGlossar = this.currentLanguageEntries[0]
        }
      }
      this.drawer = true
    },
    async injectLexiconContent(content) {
      if (!this.glossarEntries) {
        await this.loadGlossar()
      }
      this.activeEntryGlossar = {...content, index: 99999, ref: {content}}
      this.drawer = true
    },
    closeLexicon() {
      this.drawer = false
    },
    openEntryInLexicon() {
      this.showOnlyEntry = this.$vuetify.breakpoint.mdAndDown
    },
    findEntryByKey(ref) {
      if (!this.glossarEntries) {
        return null
      }
      return this.glossarEntries.find((entry) => entry.ref === ref)
    },
  },
  mounted() {
    EventBus.$on('showLexicon',
      this.showLexicon
    )
    EventBus.$on('closeLexicon',
      this.closeLexicon
    )
    EventBus.$on('injectLexiconContent',
      this.injectLexiconContent
    )
  },
  beforeDestroy() {
    EventBus.$off('showLexicon',
      this.showLexicon
    )
    EventBus.$off('closeLexicon',
      this.closeLexicon
    )
    EventBus.$off('injectLexiconContent',
      this.injectLexiconContent
    )
  }
}
</script>

<style scoped lang="scss">
@import "../../../../styles/variables.scss";

.lexicon-icon {
  color: white;
  font-size: 30px;
  margin-right: 14px;
}

.lexicon-button {
  position: fixed;
  width: auto;
  height: auto;
  bottom: 40px;
  right: 40px;
  z-index: 30;
}

.fin-lexicon {
  background-color: $fin-color-secondary-blue;
  color: white;
}

.fin-lexicon-entry {
  background-color: white;
}

::v-deep .v-input-icon {
  color: #000 !important;
}

.search-icon {
  color: $fin-color-primary-dark;
}

::v-deep .v-text-field--outlined fieldset {
  border-width: 1px !important;
  border-radius: 0 !important;
}

.to-lexicon-text {
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  cursor: pointer;
}
</style>
